module.exports = __webpack_public_path__ + "img/HawaiianDreamXmas.5e9ea4d0.png";